// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MessageCategory,
    ObjectNoResponse,
    ProviderComment,
    ProviderCommentSortType,
    ProviderCreateCommentPayload,
    ProviderCreateMessageCategoryPayload,
    ProviderCreateMessagePayload,
    ProviderMessage,
    ProviderMessageLinkPayload,
    ProviderMessageSortType,
    ProviderUpdateCommentPayload,
    ProviderUpdateMessagePayload,
    SupportComment,
    SupportCommentSortType,
    SupportCreateCommentPayload,
    SupportCreateMessageCategoryPayload,
    SupportCreateMessagePayload,
    SupportMessage,
    SupportMessageLinkPayload,
    SupportMessageSortType,
    SupportPatchMessagePayload,
    SupportUpdateCommentPayload,
    SupportUpdateMessagePayload,
    ProviderCreateCommentPayloadToJSON,
    ProviderCreateMessageCategoryPayloadToJSON,
    ProviderCreateMessagePayloadToJSON,
    ProviderMessageLinkPayloadToJSON,
    ProviderUpdateCommentPayloadToJSON,
    ProviderUpdateMessagePayloadToJSON,
    SupportCreateCommentPayloadToJSON,
    SupportCreateMessageCategoryPayloadToJSON,
    SupportCreateMessagePayloadToJSON,
    SupportMessageLinkPayloadToJSON,
    SupportPatchMessagePayloadToJSON,
    SupportUpdateCommentPayloadToJSON,
    SupportUpdateMessagePayloadToJSON,
    MessageCategoryFromJSON,
    ObjectNoResponseFromJSON,
    ProviderCommentFromJSON,
    ProviderMessageFromJSON,
    SupportCommentFromJSON,
    SupportMessageFromJSON,
} from '../models';

export interface CreateProviderCommentRequest {
    id: string;
    providerCreateCommentPayload: ProviderCreateCommentPayload;
}

export interface CreateProviderMessageRequest {
    providerCreateMessagePayload: ProviderCreateMessagePayload;
}

export interface CreateSupportCommentRequest {
    id: string;
    supportCreateCommentPayload: SupportCreateCommentPayload;
}

export interface CreateSupportMessageRequest {
    supportCreateMessagePayload: SupportCreateMessagePayload;
}

export interface DeleteProviderMessageCategoryRequest {
    id: string;
}

export interface DeleteSupportMessageCategoryRequest {
    id: string;
}

export interface GetProviderCommentRequest {
    mid: string;
    cid: string;
}

export interface GetProviderMessageRequest {
    id: string;
}

export interface GetSupportCommentRequest {
    mid: string;
    cid: string;
}

export interface GetSupportMessageRequest {
    id: string;
}

export interface ListProviderComment1Request {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderComment1OrderEnum>;
    filterCreated?: Array<string>;
    filterMessageId?: Array<string>;
    filterMessageAuthorType?: Array<string>;
    filterBody?: Array<string>;
    sort?: Array<ProviderCommentSortType>;
}

export interface ListProviderCommentsRequest {
    id: string;
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderCommentsOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderCommentSortType>;
}

export interface ListProviderMessagesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderMessagesOrderEnum>;
    filterCreated?: Array<string>;
    filterOpen?: string;
    filterRead?: string;
    filterUpdated?: Array<string>;
    filterSubject?: Array<string>;
    filterAuthor?: Array<string>;
    filterPurpose?: Array<string>;
    filterPriority?: Array<string>;
    filterDueDate?: Array<string>;
    filterUserId?: Array<string>;
    filterClaimId?: Array<string>;
    filterCodingId?: Array<string>;
    filterCollectionPaymentId?: Array<string>;
    filterEmailSendId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterFaxReceiveId?: Array<string>;
    filterFaxSendId?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterLetterId?: Array<string>;
    filterMailId?: Array<string>;
    filterMessageId?: Array<string>;
    filterMessageCategoryId?: Array<string>;
    filterPatientId?: Array<string>;
    filterPayerId?: Array<string>;
    filterPaymentId?: Array<string>;
    filterPhoneId?: Array<string>;
    filterProviderId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterTransmissionId?: Array<string>;
    filterDocumentId?: Array<string>;
    sort?: Array<ProviderMessageSortType>;
}

export interface ListSupportCommentsRequest {
    id: string;
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportCommentsOrderEnum>;
    filterCreated?: Array<string>;
    filterNote?: string;
    filterMessageAuthorType?: Array<string>;
    sort?: Array<SupportCommentSortType>;
}

export interface ListSupportComments1Request {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportComments1OrderEnum>;
    filterCreated?: Array<string>;
    filterNote?: string;
    filterMessageId?: Array<string>;
    filterMessageAuthorType?: Array<string>;
    filterBody?: Array<string>;
    sort?: Array<SupportCommentSortType>;
}

export interface ListSupportMessagesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportMessagesOrderEnum>;
    filterCreated?: Array<string>;
    filterOpen?: string;
    filterRead?: string;
    filterUpdated?: Array<string>;
    filterSubject?: Array<string>;
    filterAuthor?: Array<string>;
    filterPurpose?: Array<string>;
    filterPriority?: Array<string>;
    filterDueDate?: Array<string>;
    filterUserId?: Array<string>;
    filterClaimId?: Array<string>;
    filterCodingId?: Array<string>;
    filterCollectionPaymentId?: Array<string>;
    filterEmailSendId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterFaxReceiveId?: Array<string>;
    filterFaxSendId?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterLetterId?: Array<string>;
    filterMailId?: Array<string>;
    filterMessageId?: Array<string>;
    filterMessageCategoryId?: Array<string>;
    filterPatientId?: Array<string>;
    filterPayerId?: Array<string>;
    filterPaymentId?: Array<string>;
    filterPhoneId?: Array<string>;
    filterProviderId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterTransmissionId?: Array<string>;
    filterDocumentId?: Array<string>;
    sort?: Array<SupportMessageSortType>;
    includeProviderOwned?: boolean;
}

export interface PatchSupportMessageRequest {
    id: string;
    supportPatchMessagePayload: SupportPatchMessagePayload;
}

export interface PostProviderMessageCategoryRequest {
    providerCreateMessageCategoryPayload: ProviderCreateMessageCategoryPayload;
}

export interface PostProviderMessageLinkRequest {
    id: string;
    providerMessageLinkPayload: ProviderMessageLinkPayload;
}

export interface PostProviderMessageUnlinkRequest {
    id: string;
    providerMessageLinkPayload: ProviderMessageLinkPayload;
}

export interface PostSupportMessageCategoryRequest {
    supportCreateMessageCategoryPayload: SupportCreateMessageCategoryPayload;
}

export interface PostSupportMessageLinkRequest {
    id: string;
    supportMessageLinkPayload: SupportMessageLinkPayload;
}

export interface PostSupportMessageUnlinkRequest {
    id: string;
    supportMessageLinkPayload: SupportMessageLinkPayload;
}

export interface PutProviderMessageRequest {
    id: string;
    providerUpdateMessagePayload: ProviderUpdateMessagePayload;
}

export interface PutSupportMessageRequest {
    id: string;
    supportUpdateMessagePayload: SupportUpdateMessagePayload;
}

export interface SetProviderMessageClosedRequest {
    id: string;
}

export interface SetProviderMessageOpenRequest {
    id: string;
}

export interface SetProviderMessageReadRequest {
    id: string;
}

export interface SetProviderMessageUnreadRequest {
    id: string;
}

export interface SetSupportMessageClosedRequest {
    id: string;
}

export interface SetSupportMessageOpenRequest {
    id: string;
}

export interface SetSupportMessageReadRequest {
    id: string;
}

export interface SetSupportMessageUnreadRequest {
    id: string;
}

export interface UpdateProviderCommentRequest {
    mid: string;
    cid: string;
    providerUpdateCommentPayload: ProviderUpdateCommentPayload;
}

export interface UpdateSupportCommentRequest {
    mid: string;
    cid: string;
    supportUpdateCommentPayload: SupportUpdateCommentPayload;
}

/**
 * no description
 */
export class MessageApi extends runtime.BaseAPI {

    /**
     * Create a message comment.
     * Create a message comment
     */
    async createProviderCommentRaw(requestParameters: CreateProviderCommentRequest): Promise<runtime.ApiResponse<ProviderComment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createProviderComment.');
        }

        if (requestParameters['providerCreateCommentPayload'] === null || requestParameters['providerCreateCommentPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateCommentPayload','Required parameter requestParameters.providerCreateCommentPayload was null or undefined when calling createProviderComment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/{id}/comment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateCommentPayloadToJSON(requestParameters['providerCreateCommentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCommentFromJSON(jsonValue));
    }

    /**
     * Create a message comment.
     * Create a message comment
     */
    async createProviderComment(requestParameters: CreateProviderCommentRequest): Promise<ProviderComment> {
        const response = await this.createProviderCommentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a message.
     * Create a message
     */
    async createProviderMessageRaw(requestParameters: CreateProviderMessageRequest): Promise<runtime.ApiResponse<ProviderMessage>> {
        if (requestParameters['providerCreateMessagePayload'] === null || requestParameters['providerCreateMessagePayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateMessagePayload','Required parameter requestParameters.providerCreateMessagePayload was null or undefined when calling createProviderMessage.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateMessagePayloadToJSON(requestParameters['providerCreateMessagePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderMessageFromJSON(jsonValue));
    }

    /**
     * Create a message.
     * Create a message
     */
    async createProviderMessage(requestParameters: CreateProviderMessageRequest): Promise<ProviderMessage> {
        const response = await this.createProviderMessageRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a message comment.
     * Create a message comment
     */
    async createSupportCommentRaw(requestParameters: CreateSupportCommentRequest): Promise<runtime.ApiResponse<SupportComment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportComment.');
        }

        if (requestParameters['supportCreateCommentPayload'] === null || requestParameters['supportCreateCommentPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateCommentPayload','Required parameter requestParameters.supportCreateCommentPayload was null or undefined when calling createSupportComment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{id}/comment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateCommentPayloadToJSON(requestParameters['supportCreateCommentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCommentFromJSON(jsonValue));
    }

    /**
     * Create a message comment.
     * Create a message comment
     */
    async createSupportComment(requestParameters: CreateSupportCommentRequest): Promise<SupportComment> {
        const response = await this.createSupportCommentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a message.
     * Create a message
     */
    async createSupportMessageRaw(requestParameters: CreateSupportMessageRequest): Promise<runtime.ApiResponse<SupportMessage>> {
        if (requestParameters['supportCreateMessagePayload'] === null || requestParameters['supportCreateMessagePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateMessagePayload','Required parameter requestParameters.supportCreateMessagePayload was null or undefined when calling createSupportMessage.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateMessagePayloadToJSON(requestParameters['supportCreateMessagePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportMessageFromJSON(jsonValue));
    }

    /**
     * Create a message.
     * Create a message
     */
    async createSupportMessage(requestParameters: CreateSupportMessageRequest): Promise<SupportMessage> {
        const response = await this.createSupportMessageRaw(requestParameters);
        return await response.value();
    }

    /**
     * Delete a message category
     * Delete a message category
     */
    async deleteProviderMessageCategoryRaw(requestParameters: DeleteProviderMessageCategoryRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteProviderMessageCategory.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message_category/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Delete a message category
     * Delete a message category
     */
    async deleteProviderMessageCategory(requestParameters: DeleteProviderMessageCategoryRequest): Promise<ObjectNoResponse> {
        const response = await this.deleteProviderMessageCategoryRaw(requestParameters);
        return await response.value();
    }

    /**
     * Delete a message category
     * Delete a message category
     */
    async deleteSupportMessageCategoryRaw(requestParameters: DeleteSupportMessageCategoryRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteSupportMessageCategory.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message_category/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Delete a message category
     * Delete a message category
     */
    async deleteSupportMessageCategory(requestParameters: DeleteSupportMessageCategoryRequest): Promise<ObjectNoResponse> {
        const response = await this.deleteSupportMessageCategoryRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a message comment
     * Get a message comment
     */
    async getProviderCommentRaw(requestParameters: GetProviderCommentRequest): Promise<runtime.ApiResponse<ProviderComment>> {
        if (requestParameters['mid'] === null || requestParameters['mid'] === undefined) {
            throw new runtime.RequiredError('mid','Required parameter requestParameters.mid was null or undefined when calling getProviderComment.');
        }

        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling getProviderComment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/{mid}/comment/{cid}`.replace(`{${"mid"}}`, encodeURIComponent(String(requestParameters.mid))).replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCommentFromJSON(jsonValue));
    }

    /**
     * Gets a message comment
     * Get a message comment
     */
    async getProviderComment(requestParameters: GetProviderCommentRequest): Promise<ProviderComment> {
        const response = await this.getProviderCommentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a message
     * Get a message
     */
    async getProviderMessageRaw(requestParameters: GetProviderMessageRequest): Promise<runtime.ApiResponse<ProviderMessage>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderMessage.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderMessageFromJSON(jsonValue));
    }

    /**
     * Gets a message
     * Get a message
     */
    async getProviderMessage(requestParameters: GetProviderMessageRequest): Promise<ProviderMessage> {
        const response = await this.getProviderMessageRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a message comment
     * Get a message comment
     */
    async getSupportCommentRaw(requestParameters: GetSupportCommentRequest): Promise<runtime.ApiResponse<SupportComment>> {
        if (requestParameters['mid'] === null || requestParameters['mid'] === undefined) {
            throw new runtime.RequiredError('mid','Required parameter requestParameters.mid was null or undefined when calling getSupportComment.');
        }

        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling getSupportComment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{mid}/comment/{cid}`.replace(`{${"mid"}}`, encodeURIComponent(String(requestParameters.mid))).replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCommentFromJSON(jsonValue));
    }

    /**
     * Gets a message comment
     * Get a message comment
     */
    async getSupportComment(requestParameters: GetSupportCommentRequest): Promise<SupportComment> {
        const response = await this.getSupportCommentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a message
     * Get a message
     */
    async getSupportMessageRaw(requestParameters: GetSupportMessageRequest): Promise<runtime.ApiResponse<SupportMessage>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportMessage.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportMessageFromJSON(jsonValue));
    }

    /**
     * Gets a message
     * Get a message
     */
    async getSupportMessage(requestParameters: GetSupportMessageRequest): Promise<SupportMessage> {
        const response = await this.getSupportMessageRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of message comments
     * Get a list of message comments
     */
    async listProviderComment1Raw(requestParameters: ListProviderComment1Request): Promise<runtime.ApiResponse<Array<ProviderComment>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterMessageId) {
            queryParameters['filterMessageId'] = requestParameters.filterMessageId;
        }

        if (requestParameters.filterMessageAuthorType) {
            queryParameters['filterMessageAuthorType'] = requestParameters.filterMessageAuthorType;
        }

        if (requestParameters.filterBody) {
            queryParameters['filterBody'] = requestParameters.filterBody;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/comment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderCommentFromJSON));
    }

    /**
     * Gets a list of message comments
     * Get a list of message comments
     */
    async listProviderComment1(requestParameters: ListProviderComment1Request): Promise<Array<ProviderComment>> {
        const response = await this.listProviderComment1Raw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of message comments
     * Get a list of message comments
     */
    async listProviderCommentsRaw(requestParameters: ListProviderCommentsRequest): Promise<runtime.ApiResponse<Array<ProviderComment>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling listProviderComments.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/{id}/comment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderCommentFromJSON));
    }

    /**
     * Gets a list of message comments
     * Get a list of message comments
     */
    async listProviderComments(requestParameters: ListProviderCommentsRequest): Promise<Array<ProviderComment>> {
        const response = await this.listProviderCommentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of message categories
     * Get a list of message categories
     */
    async listProviderMessageCategoryRaw(): Promise<runtime.ApiResponse<Array<MessageCategory>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message_category`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MessageCategoryFromJSON));
    }

    /**
     * Get a list of message categories
     * Get a list of message categories
     */
    async listProviderMessageCategory(): Promise<Array<MessageCategory>> {
        const response = await this.listProviderMessageCategoryRaw();
        return await response.value();
    }

    /**
     * Gets a list of messages
     * Get a list of messages
     */
    async listProviderMessagesRaw(requestParameters: ListProviderMessagesRequest): Promise<runtime.ApiResponse<Array<ProviderMessage>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterOpen !== undefined) {
            queryParameters['filterOpen'] = requestParameters.filterOpen;
        }

        if (requestParameters.filterRead !== undefined) {
            queryParameters['filterRead'] = requestParameters.filterRead;
        }

        if (requestParameters.filterUpdated) {
            queryParameters['filterUpdated'] = requestParameters.filterUpdated;
        }

        if (requestParameters.filterSubject) {
            queryParameters['filterSubject'] = requestParameters.filterSubject;
        }

        if (requestParameters.filterAuthor) {
            queryParameters['filterAuthor'] = requestParameters.filterAuthor;
        }

        if (requestParameters.filterPurpose) {
            queryParameters['filterPurpose'] = requestParameters.filterPurpose;
        }

        if (requestParameters.filterPriority) {
            queryParameters['filterPriority'] = requestParameters.filterPriority;
        }

        if (requestParameters.filterDueDate) {
            queryParameters['filterDueDate'] = requestParameters.filterDueDate;
        }

        if (requestParameters.filterUserId) {
            queryParameters['filterUserId'] = requestParameters.filterUserId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterCodingId) {
            queryParameters['filterCodingId'] = requestParameters.filterCodingId;
        }

        if (requestParameters.filterCollectionPaymentId) {
            queryParameters['filterCollectionPaymentId'] = requestParameters.filterCollectionPaymentId;
        }

        if (requestParameters.filterEmailSendId) {
            queryParameters['filterEmailSendId'] = requestParameters.filterEmailSendId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterFaxReceiveId) {
            queryParameters['filterFaxReceiveId'] = requestParameters.filterFaxReceiveId;
        }

        if (requestParameters.filterFaxSendId) {
            queryParameters['filterFaxSendId'] = requestParameters.filterFaxSendId;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterLetterId) {
            queryParameters['filterLetterId'] = requestParameters.filterLetterId;
        }

        if (requestParameters.filterMailId) {
            queryParameters['filterMailId'] = requestParameters.filterMailId;
        }

        if (requestParameters.filterMessageId) {
            queryParameters['filterMessageId'] = requestParameters.filterMessageId;
        }

        if (requestParameters.filterMessageCategoryId) {
            queryParameters['filterMessageCategoryId'] = requestParameters.filterMessageCategoryId;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterPhoneId) {
            queryParameters['filterPhoneId'] = requestParameters.filterPhoneId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterTransmissionId) {
            queryParameters['filterTransmissionId'] = requestParameters.filterTransmissionId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderMessageFromJSON));
    }

    /**
     * Gets a list of messages
     * Get a list of messages
     */
    async listProviderMessages(requestParameters: ListProviderMessagesRequest): Promise<Array<ProviderMessage>> {
        const response = await this.listProviderMessagesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of message comments
     * Get a list of message comments
     */
    async listSupportCommentsRaw(requestParameters: ListSupportCommentsRequest): Promise<runtime.ApiResponse<Array<SupportComment>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling listSupportComments.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterNote !== undefined) {
            queryParameters['filterNote'] = requestParameters.filterNote;
        }

        if (requestParameters.filterMessageAuthorType) {
            queryParameters['filterMessageAuthorType'] = requestParameters.filterMessageAuthorType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{id}/comment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportCommentFromJSON));
    }

    /**
     * Gets a list of message comments
     * Get a list of message comments
     */
    async listSupportComments(requestParameters: ListSupportCommentsRequest): Promise<Array<SupportComment>> {
        const response = await this.listSupportCommentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of message comments
     * Get a list of message comments
     */
    async listSupportComments1Raw(requestParameters: ListSupportComments1Request): Promise<runtime.ApiResponse<Array<SupportComment>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterNote !== undefined) {
            queryParameters['filterNote'] = requestParameters.filterNote;
        }

        if (requestParameters.filterMessageId) {
            queryParameters['filterMessageId'] = requestParameters.filterMessageId;
        }

        if (requestParameters.filterMessageAuthorType) {
            queryParameters['filterMessageAuthorType'] = requestParameters.filterMessageAuthorType;
        }

        if (requestParameters.filterBody) {
            queryParameters['filterBody'] = requestParameters.filterBody;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/comment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportCommentFromJSON));
    }

    /**
     * Gets a list of message comments
     * Get a list of message comments
     */
    async listSupportComments1(requestParameters: ListSupportComments1Request): Promise<Array<SupportComment>> {
        const response = await this.listSupportComments1Raw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of message categories
     * Get a list of message categories
     */
    async listSupportMessageCategoryRaw(): Promise<runtime.ApiResponse<Array<MessageCategory>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message_category`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MessageCategoryFromJSON));
    }

    /**
     * Get a list of message categories
     * Get a list of message categories
     */
    async listSupportMessageCategory(): Promise<Array<MessageCategory>> {
        const response = await this.listSupportMessageCategoryRaw();
        return await response.value();
    }

    /**
     * Gets a list of messages. PROVIDER_OWNED messages are excluded unless includeProviderOwned is true, even when filterPurpose requests them.
     * Get a list of messages
     */
    async listSupportMessagesRaw(requestParameters: ListSupportMessagesRequest): Promise<runtime.ApiResponse<Array<SupportMessage>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterOpen !== undefined) {
            queryParameters['filterOpen'] = requestParameters.filterOpen;
        }

        if (requestParameters.filterRead !== undefined) {
            queryParameters['filterRead'] = requestParameters.filterRead;
        }

        if (requestParameters.filterUpdated) {
            queryParameters['filterUpdated'] = requestParameters.filterUpdated;
        }

        if (requestParameters.filterSubject) {
            queryParameters['filterSubject'] = requestParameters.filterSubject;
        }

        if (requestParameters.filterAuthor) {
            queryParameters['filterAuthor'] = requestParameters.filterAuthor;
        }

        if (requestParameters.filterPurpose) {
            queryParameters['filterPurpose'] = requestParameters.filterPurpose;
        }

        if (requestParameters.filterPriority) {
            queryParameters['filterPriority'] = requestParameters.filterPriority;
        }

        if (requestParameters.filterDueDate) {
            queryParameters['filterDueDate'] = requestParameters.filterDueDate;
        }

        if (requestParameters.filterUserId) {
            queryParameters['filterUserId'] = requestParameters.filterUserId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterCodingId) {
            queryParameters['filterCodingId'] = requestParameters.filterCodingId;
        }

        if (requestParameters.filterCollectionPaymentId) {
            queryParameters['filterCollectionPaymentId'] = requestParameters.filterCollectionPaymentId;
        }

        if (requestParameters.filterEmailSendId) {
            queryParameters['filterEmailSendId'] = requestParameters.filterEmailSendId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterFaxReceiveId) {
            queryParameters['filterFaxReceiveId'] = requestParameters.filterFaxReceiveId;
        }

        if (requestParameters.filterFaxSendId) {
            queryParameters['filterFaxSendId'] = requestParameters.filterFaxSendId;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterLetterId) {
            queryParameters['filterLetterId'] = requestParameters.filterLetterId;
        }

        if (requestParameters.filterMailId) {
            queryParameters['filterMailId'] = requestParameters.filterMailId;
        }

        if (requestParameters.filterMessageId) {
            queryParameters['filterMessageId'] = requestParameters.filterMessageId;
        }

        if (requestParameters.filterMessageCategoryId) {
            queryParameters['filterMessageCategoryId'] = requestParameters.filterMessageCategoryId;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterPhoneId) {
            queryParameters['filterPhoneId'] = requestParameters.filterPhoneId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterTransmissionId) {
            queryParameters['filterTransmissionId'] = requestParameters.filterTransmissionId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.includeProviderOwned !== undefined) {
            queryParameters['includeProviderOwned'] = requestParameters.includeProviderOwned;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportMessageFromJSON));
    }

    /**
     * Gets a list of messages. PROVIDER_OWNED messages are excluded unless includeProviderOwned is true, even when filterPurpose requests them.
     * Get a list of messages
     */
    async listSupportMessages(requestParameters: ListSupportMessagesRequest): Promise<Array<SupportMessage>> {
        const response = await this.listSupportMessagesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Patch a message
     * Patch a message
     */
    async patchSupportMessageRaw(requestParameters: PatchSupportMessageRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling patchSupportMessage.');
        }

        if (requestParameters['supportPatchMessagePayload'] === null || requestParameters['supportPatchMessagePayload'] === undefined) {
            throw new runtime.RequiredError('supportPatchMessagePayload','Required parameter requestParameters.supportPatchMessagePayload was null or undefined when calling patchSupportMessage.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SupportPatchMessagePayloadToJSON(requestParameters['supportPatchMessagePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Patch a message
     * Patch a message
     */
    async patchSupportMessage(requestParameters: PatchSupportMessageRequest): Promise<ObjectNoResponse> {
        const response = await this.patchSupportMessageRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a message category
     * Create a message category
     */
    async postProviderMessageCategoryRaw(requestParameters: PostProviderMessageCategoryRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['providerCreateMessageCategoryPayload'] === null || requestParameters['providerCreateMessageCategoryPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateMessageCategoryPayload','Required parameter requestParameters.providerCreateMessageCategoryPayload was null or undefined when calling postProviderMessageCategory.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message_category`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateMessageCategoryPayloadToJSON(requestParameters['providerCreateMessageCategoryPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Create a message category
     * Create a message category
     */
    async postProviderMessageCategory(requestParameters: PostProviderMessageCategoryRequest): Promise<ObjectNoResponse> {
        const response = await this.postProviderMessageCategoryRaw(requestParameters);
        return await response.value();
    }

    /**
     * Link a message to one or more entities
     * Link a message to one or more entities
     */
    async postProviderMessageLinkRaw(requestParameters: PostProviderMessageLinkRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderMessageLink.');
        }

        if (requestParameters['providerMessageLinkPayload'] === null || requestParameters['providerMessageLinkPayload'] === undefined) {
            throw new runtime.RequiredError('providerMessageLinkPayload','Required parameter requestParameters.providerMessageLinkPayload was null or undefined when calling postProviderMessageLink.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/{id}/link`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderMessageLinkPayloadToJSON(requestParameters['providerMessageLinkPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Link a message to one or more entities
     * Link a message to one or more entities
     */
    async postProviderMessageLink(requestParameters: PostProviderMessageLinkRequest): Promise<ObjectNoResponse> {
        const response = await this.postProviderMessageLinkRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unlink a message from one or more entities
     * Unlink a message from one or more entities
     */
    async postProviderMessageUnlinkRaw(requestParameters: PostProviderMessageUnlinkRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderMessageUnlink.');
        }

        if (requestParameters['providerMessageLinkPayload'] === null || requestParameters['providerMessageLinkPayload'] === undefined) {
            throw new runtime.RequiredError('providerMessageLinkPayload','Required parameter requestParameters.providerMessageLinkPayload was null or undefined when calling postProviderMessageUnlink.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/{id}/unlink`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderMessageLinkPayloadToJSON(requestParameters['providerMessageLinkPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Unlink a message from one or more entities
     * Unlink a message from one or more entities
     */
    async postProviderMessageUnlink(requestParameters: PostProviderMessageUnlinkRequest): Promise<ObjectNoResponse> {
        const response = await this.postProviderMessageUnlinkRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a message category
     * Create a message category
     */
    async postSupportMessageCategoryRaw(requestParameters: PostSupportMessageCategoryRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportCreateMessageCategoryPayload'] === null || requestParameters['supportCreateMessageCategoryPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateMessageCategoryPayload','Required parameter requestParameters.supportCreateMessageCategoryPayload was null or undefined when calling postSupportMessageCategory.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message_category`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateMessageCategoryPayloadToJSON(requestParameters['supportCreateMessageCategoryPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Create a message category
     * Create a message category
     */
    async postSupportMessageCategory(requestParameters: PostSupportMessageCategoryRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportMessageCategoryRaw(requestParameters);
        return await response.value();
    }

    /**
     * Link a message to one or more entities
     * Link a message to one or more entities
     */
    async postSupportMessageLinkRaw(requestParameters: PostSupportMessageLinkRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportMessageLink.');
        }

        if (requestParameters['supportMessageLinkPayload'] === null || requestParameters['supportMessageLinkPayload'] === undefined) {
            throw new runtime.RequiredError('supportMessageLinkPayload','Required parameter requestParameters.supportMessageLinkPayload was null or undefined when calling postSupportMessageLink.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{id}/link`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportMessageLinkPayloadToJSON(requestParameters['supportMessageLinkPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Link a message to one or more entities
     * Link a message to one or more entities
     */
    async postSupportMessageLink(requestParameters: PostSupportMessageLinkRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportMessageLinkRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unlink a message from one or more entities
     * Unlink a message from one or more entities
     */
    async postSupportMessageUnlinkRaw(requestParameters: PostSupportMessageUnlinkRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportMessageUnlink.');
        }

        if (requestParameters['supportMessageLinkPayload'] === null || requestParameters['supportMessageLinkPayload'] === undefined) {
            throw new runtime.RequiredError('supportMessageLinkPayload','Required parameter requestParameters.supportMessageLinkPayload was null or undefined when calling postSupportMessageUnlink.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{id}/unlink`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportMessageLinkPayloadToJSON(requestParameters['supportMessageLinkPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Unlink a message from one or more entities
     * Unlink a message from one or more entities
     */
    async postSupportMessageUnlink(requestParameters: PostSupportMessageUnlinkRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportMessageUnlinkRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a message
     * Update a message
     */
    async putProviderMessageRaw(requestParameters: PutProviderMessageRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling putProviderMessage.');
        }

        if (requestParameters['providerUpdateMessagePayload'] === null || requestParameters['providerUpdateMessagePayload'] === undefined) {
            throw new runtime.RequiredError('providerUpdateMessagePayload','Required parameter requestParameters.providerUpdateMessagePayload was null or undefined when calling putProviderMessage.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderUpdateMessagePayloadToJSON(requestParameters['providerUpdateMessagePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a message
     * Update a message
     */
    async putProviderMessage(requestParameters: PutProviderMessageRequest): Promise<ObjectNoResponse> {
        const response = await this.putProviderMessageRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a message
     * Update a message
     */
    async putSupportMessageRaw(requestParameters: PutSupportMessageRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling putSupportMessage.');
        }

        if (requestParameters['supportUpdateMessagePayload'] === null || requestParameters['supportUpdateMessagePayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateMessagePayload','Required parameter requestParameters.supportUpdateMessagePayload was null or undefined when calling putSupportMessage.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateMessagePayloadToJSON(requestParameters['supportUpdateMessagePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a message
     * Update a message
     */
    async putSupportMessage(requestParameters: PutSupportMessageRequest): Promise<ObjectNoResponse> {
        const response = await this.putSupportMessageRaw(requestParameters);
        return await response.value();
    }

    /**
     * Mark a provider message closed
     * Marks a provider message as closed
     */
    async setProviderMessageClosedRaw(requestParameters: SetProviderMessageClosedRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setProviderMessageClosed.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/{id}/close`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Mark a provider message closed
     * Marks a provider message as closed
     */
    async setProviderMessageClosed(requestParameters: SetProviderMessageClosedRequest): Promise<ObjectNoResponse> {
        const response = await this.setProviderMessageClosedRaw(requestParameters);
        return await response.value();
    }

    /**
     * Mark a provider message open
     * Marks a provider message as open
     */
    async setProviderMessageOpenRaw(requestParameters: SetProviderMessageOpenRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setProviderMessageOpen.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/{id}/open`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Mark a provider message open
     * Marks a provider message as open
     */
    async setProviderMessageOpen(requestParameters: SetProviderMessageOpenRequest): Promise<ObjectNoResponse> {
        const response = await this.setProviderMessageOpenRaw(requestParameters);
        return await response.value();
    }

    /**
     * Mark a provider message read
     * Marks a provider message as read
     */
    async setProviderMessageReadRaw(requestParameters: SetProviderMessageReadRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setProviderMessageRead.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/{id}/read`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Mark a provider message read
     * Marks a provider message as read
     */
    async setProviderMessageRead(requestParameters: SetProviderMessageReadRequest): Promise<ObjectNoResponse> {
        const response = await this.setProviderMessageReadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Mark a provider message unread
     * Marks a provider message as unread
     */
    async setProviderMessageUnreadRaw(requestParameters: SetProviderMessageUnreadRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setProviderMessageUnread.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/{id}/unread`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Mark a provider message unread
     * Marks a provider message as unread
     */
    async setProviderMessageUnread(requestParameters: SetProviderMessageUnreadRequest): Promise<ObjectNoResponse> {
        const response = await this.setProviderMessageUnreadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Mark a support message closed
     * Marks a support message as closed
     */
    async setSupportMessageClosedRaw(requestParameters: SetSupportMessageClosedRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setSupportMessageClosed.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{id}/close`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Mark a support message closed
     * Marks a support message as closed
     */
    async setSupportMessageClosed(requestParameters: SetSupportMessageClosedRequest): Promise<ObjectNoResponse> {
        const response = await this.setSupportMessageClosedRaw(requestParameters);
        return await response.value();
    }

    /**
     * Mark a support message open
     * Marks a support message as open
     */
    async setSupportMessageOpenRaw(requestParameters: SetSupportMessageOpenRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setSupportMessageOpen.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{id}/open`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Mark a support message open
     * Marks a support message as open
     */
    async setSupportMessageOpen(requestParameters: SetSupportMessageOpenRequest): Promise<ObjectNoResponse> {
        const response = await this.setSupportMessageOpenRaw(requestParameters);
        return await response.value();
    }

    /**
     * Mark a support message read
     * Marks a support message as read
     */
    async setSupportMessageReadRaw(requestParameters: SetSupportMessageReadRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setSupportMessageRead.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{id}/read`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Mark a support message read
     * Marks a support message as read
     */
    async setSupportMessageRead(requestParameters: SetSupportMessageReadRequest): Promise<ObjectNoResponse> {
        const response = await this.setSupportMessageReadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Mark a support message unread
     * Marks a support message as unread
     */
    async setSupportMessageUnreadRaw(requestParameters: SetSupportMessageUnreadRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setSupportMessageUnread.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{id}/unread`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Mark a support message unread
     * Marks a support message as unread
     */
    async setSupportMessageUnread(requestParameters: SetSupportMessageUnreadRequest): Promise<ObjectNoResponse> {
        const response = await this.setSupportMessageUnreadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a message comment
     * Update a message comment
     */
    async updateProviderCommentRaw(requestParameters: UpdateProviderCommentRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['mid'] === null || requestParameters['mid'] === undefined) {
            throw new runtime.RequiredError('mid','Required parameter requestParameters.mid was null or undefined when calling updateProviderComment.');
        }

        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling updateProviderComment.');
        }

        if (requestParameters['providerUpdateCommentPayload'] === null || requestParameters['providerUpdateCommentPayload'] === undefined) {
            throw new runtime.RequiredError('providerUpdateCommentPayload','Required parameter requestParameters.providerUpdateCommentPayload was null or undefined when calling updateProviderComment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/message/{mid}/comment/{cid}`.replace(`{${"mid"}}`, encodeURIComponent(String(requestParameters.mid))).replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderUpdateCommentPayloadToJSON(requestParameters['providerUpdateCommentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a message comment
     * Update a message comment
     */
    async updateProviderComment(requestParameters: UpdateProviderCommentRequest): Promise<ObjectNoResponse> {
        const response = await this.updateProviderCommentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a message comment
     * Update a message comment
     */
    async updateSupportCommentRaw(requestParameters: UpdateSupportCommentRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['mid'] === null || requestParameters['mid'] === undefined) {
            throw new runtime.RequiredError('mid','Required parameter requestParameters.mid was null or undefined when calling updateSupportComment.');
        }

        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling updateSupportComment.');
        }

        if (requestParameters['supportUpdateCommentPayload'] === null || requestParameters['supportUpdateCommentPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateCommentPayload','Required parameter requestParameters.supportUpdateCommentPayload was null or undefined when calling updateSupportComment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:message", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/message/{mid}/comment/{cid}`.replace(`{${"mid"}}`, encodeURIComponent(String(requestParameters.mid))).replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateCommentPayloadToJSON(requestParameters['supportUpdateCommentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a message comment
     * Update a message comment
     */
    async updateSupportComment(requestParameters: UpdateSupportCommentRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportCommentRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderComment1OrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderCommentsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderMessagesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportCommentsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportComments1OrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportMessagesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
